export default __webpack_public_path__ + "static/1526-9ebc5a52b1ab0af5e0b021cc2379a9b9.gif";